import { render, staticRenderFns } from "./FwzcView.vue?vue&type=template&id=331de99e&scoped=true&"
import script from "./FwzcView.vue?vue&type=script&lang=js&"
export * from "./FwzcView.vue?vue&type=script&lang=js&"
import style0 from "./FwzcView.vue?vue&type=style&index=0&id=331de99e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331de99e",
  null
  
)

export default component.exports